import React, { createContext, useContext, useState } from 'react'

const ProcessingPollingContext = createContext()

export const ProcessingPollingProvider = ({ children }) => {
    const [pollingData, setPollingData] = useState(null)

    const startPolling = (data) => {
        setPollingData(data)
    }

    const stopPolling = () => {
        setPollingData(null)
    }

    return (
        <ProcessingPollingContext.Provider
            value={{
                pollingData,
                startPolling,
                stopPolling,
            }}
        >
            {children}
        </ProcessingPollingContext.Provider>
    )
}

export const useProcessingPollingContext = () => {
    const context = useContext(ProcessingPollingContext)
    if (!context) {
        throw new Error('useProcessingPollingContext must be used within ProcessingPollingProvider')
    }
    return context
}
